import { request } from './client';
import type {
  HealthResponse,
  InviteLookup,
  InviteRegister,
  SignupOpen,
  SignupRequest,
  SignupResult,
  TrialState,
  LoginRequest,
  MeResponse,
  OutletRef,
  SelectOutletRequest,
  SelectTenantRequest,
  SetupPasswordRequest,
  ChangePasswordRequest,
} from '@kassa/shared';

export const authApi = {
  me: () => request<MeResponse>('GET', '/api/me'),
  login: (body: LoginRequest) => request<MeResponse>('POST', '/api/auth/login', body),
  selectTenant: (body: SelectTenantRequest) => request<MeResponse>('POST', '/api/auth/tenant', body),
  setupPassword: (body: SetupPasswordRequest) => request<void>('POST', '/api/auth/setup', body),
  changePassword: (body: ChangePasswordRequest) => request<MeResponse>('POST', '/api/auth/password', body),
  logout: () => request<void>('POST', '/api/auth/logout'),
  passwordResetRequest: (identifier: string) => request<{ message: string }>('POST', '/api/auth/password-reset/request', { identifier }),
  passwordResetConfirm: (code: string, password: string) => request<void>('POST', '/api/auth/password-reset/confirm', { code, password }),
  verifyEmail: (code: string) => request<void>('POST', '/api/auth/email/verify', { code }),
  // Öz qeydiyyatı (KT-85)
  signupOpen: () => request<SignupOpen>('GET', '/api/auth/signup/open'),
  signup: (body: SignupRequest) => request<SignupResult>('POST', '/api/auth/signup', body),
  trial: () => request<TrialState>('GET', '/api/trial'),
  inviteLookup: (code: string) => request<InviteLookup>('POST', '/api/auth/invite/lookup', { code }),
  inviteRegister: (body: InviteRegister) => request<MeResponse>('POST', '/api/auth/invite/register', body),
  // Google ilə qeydiyyat (KT-84): forma serverdə saxlanır, cavab — Google ünvanı
  inviteGoogle: (body: Omit<InviteRegister, 'password'>) => request<{ url: string }>('POST', '/api/auth/google/invite', body),
  outlets: () => request<OutletRef[]>('GET', '/api/outlets'),
  selectOutlet: (body: SelectOutletRequest) => request<MeResponse>('POST', '/api/auth/outlet', body),
  health: () => fetch('/health', { cache: 'no-store' }).then((r) => r.json() as Promise<HealthResponse>),
};
